import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IRegistrationSubmission } from '../../models/account/registration-submission';
import { ILabSubmission } from '../../models/account/lab-submission';
import { IRegistrationResult } from '../../models/account/registrationResult';
import { ILabUser } from '../../models/lab-user-menu/lab-user';
import { IUserUpdate } from '../../models/account/user-update';
import { IUpdateUserResult } from '../../models/account/user-update-result';
import { DNTCaptchaApiResponse } from '../../models/dnt-captcha/dnt-captcha-api-response';
import { environment } from '@env/environment';
import { ILogin } from 'app/models/account/login';
import { IPhlLabReg, IUserList } from 'app/models/account/manageUsers';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

const dntOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded'
  })
};

@Injectable({
  providedIn: 'root',
})

export class AccountService {
  private api: string = environment.privateApi + 'Account/';
  loginName: string = null;

  states: string[] = [
    "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA", "HI", "ID", "IL",
    "IN", "IA", "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT",
    "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI",
    "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"
  ];

  constructor(private http: HttpClient) {}

  logLogin(): Observable<void> {
    // console.log("Logging login for user: ", this.loginName);
    return this.http.get<void>(this.api + "logLogin");
  }  
  
  // login(login: ILogin ): Observable<ILabUser> {
  //   return this.http.post<ILabUser>(this.api + "login", login, httpOptions);
  // }

  logout(): Observable<void> {
    return this.http.get<void>(this.api + "logout", httpOptions);
  }

  getRoles(): Observable<string []> {
    return this.http.get<string []>(this.api + 'getRoles', httpOptions);
  }

  getUserRoles(loginName: string): Observable<string []> {
    return this.http.get<string []>(this.api + 'getUserRoles/' + loginName, httpOptions);
  }

  getCaptcha(): Observable<DNTCaptchaApiResponse> {
    return this.http.get<DNTCaptchaApiResponse>(this.api + 'getCaptcha', httpOptions);
  }

  register(registration: HttpParams): Observable<IRegistrationResult> {
    return this.http.post<IRegistrationResult>(this.api + "register", registration, dntOptions);
  }

  getRegistrationLabs(): Observable<ILabSubmission[]> {
    return this.http.get<ILabSubmission[]>(this.api + 'getRegistrationLabs', httpOptions);
  }

  registerLabs(labRegistration: IRegistrationSubmission): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'registerLabs', labRegistration, httpOptions);
  }

  resetForgottenPassword(email: string): Observable<boolean> {
    return this.http.get<boolean>(this.api + 'forgotPassword/' + email, httpOptions);
  }

  getUserInfo(): Observable<IUserUpdate>{
    return this.http.get<IUserUpdate>(this.api + 'getUser', httpOptions);
  }

  updateUser(user: IUserUpdate): Observable<IUpdateUserResult> {
    return this.http.post<IUpdateUserResult>(this.api + "updateUser", user, httpOptions);
  }

  getUserList(searchBy: string): Observable<IUserList[]> {
    return this.http.get<IUserList[]> (this.api + 'getUserList/' +  searchBy,  httpOptions)
  }
  
  getSingleUser(loginName: string): Observable<IUserUpdate> {
    return this.http.get<IUserUpdate> (this.api + 'getSingleUser/' +  loginName,  httpOptions)
  }

  getUserLabs(registrationId: number): Observable<IPhlLabReg[]> {
    return this.http.get<IPhlLabReg[]> (this.api + 'getUserLabs/' +  registrationId,  httpOptions)
  }

  addRoles(login: string, roles: string[]): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'addUserRoles/' + login, roles, httpOptions);
  }

  deleteRoles(loginName: string, roles: string[]): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'deleteUserRoles/' + loginName, roles, httpOptions);
  }

  addUserLabs(registrationId: number, orelapIds: string): Observable<boolean> {
    return this.http.get<boolean> (this.api + 'addUserLabs/' +  registrationId +
        '/' + orelapIds, httpOptions)
  }

  deleteUserLabs(registrationId: number, orelapIds: string): Observable<boolean> {
    return this.http.get<boolean> (this.api + 'deleteUserLabs/' +  registrationId +
        '/' + orelapIds,  httpOptions)
  }

  getUserLabsList(registrationId: number): Observable<IPhlLabReg[]> {
    return this.http.get<IPhlLabReg[]> (this.api + 'getUserLabsList/' +  registrationId,  httpOptions)
  }

  emailNotification(loginName: string, status: string): Observable<boolean> {
    return this.http.get<boolean> (this.api + 'emailNotification/' +  loginName +
        '/' + status,  httpOptions)
  }

  getAppUser(): Observable<IUserUpdate>{
    return this.http.get<IUserUpdate>(this.api + 'getUser', httpOptions);
  }

  updateAppUser(user: IUserUpdate): Observable<IUpdateUserResult> {
    return this.http.post<IUpdateUserResult>(this.api + "updateUser", user, httpOptions);
  }
}
